

import service from '../request/index'


// 资源总量统计
export function getTotalResourceCount () {
  return service({
    url: '/es/resource/lib/getTotalResourceCount',
    method: 'GET',
  })
}

// 资源库首页列表
export function resourceHomepageList (data) {
  return service({
    url: '/es/resource/lib/resourceHomepageList',
    method: 'POST',
    data
  })
}



// 用户排行榜
export function getMemberRankByResourceLibId () {
  return service({
    url: '/es/resource/lib/getMemberRankByResourceLibId',
    method: 'GET',
  })
}



// 资源热度榜
export function getResourceRankByResourceLibId () {
  return service({
    url: '/es/resource/lib/getResourceRankByResourceLibId',
    method: 'GET',
  })
}


// 首页访问量
export function homeView () {
  return service({
    url: '/es/resource/view/home/view',
    method: 'GET',
  })
}
export function onlinePreview (data) {
  return service({
    url: '/api/open/onlinePreview',
    method: 'GET',
    params: data
  })
}

// 预览文件
export function onlinePreviewRelative (data) {
  return service({
    url: '/api/open/onlinePreviewRelative',
    method: 'GET',
    params: data
  })
}




